import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    menuList: Array,
    zhsRole: Number // 角色

  },

  data() {
    return {};
  },

  methods: {
    zhsLogin() {
      handleLogin(this.$schoolId);
    }

  }
};